import React, { useEffect, useState } from "react";
import Sidebarmenu from "../../SideMenu/Sidemenu";
import TopHeader from "../../TopHeader/TopHeader";
import "../MyHistory/MyHistory.css";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  ViewBookAppointment,
  getCountries,
  appointmentReferralOption,
} from "../../../../Helper/Redux/API";
import Modal from "react-modal";
import moment from "moment";
import { ImCross } from "react-icons/im";
import Offcanvas from "react-bootstrap/Offcanvas";
import loder from "../../../../img/loder3.gif";
function MyHistory() {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const dispatch = useDispatch();
  const [getappointment, setGetAppointment] = useState("");
  const [showview, setShowview] = useState(false);
  const [date, setDate] = useState("");
  const [eventview, setEventView] = useState("");
  const [addmenuopen, setAddMenuOpen] = useState(false);
  const [creactdate, setCreactDate] = useState("");
  const [selectcenter, setSelectCenter] = useState("1");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [gandar, setGander] = useState("");
  const [dob, setDOB] = useState("");
  const [address, setAddress] = useState("");
  const [occupation, setOccupation] = useState("");
  const [languagesspoken, setLanguagesSpoken] = useState("");
  const [nationality, setNationality] = useState("");
  const [mobilenumber, setMobileNumber] = useState("");
  const [officenumber, setOfficeNumber] = useState("");
  const [Homenumber, setHomeNumber] = useState("");
  const [address2, setAddress2] = useState("");
  const [Postalcode, setPostalcode] = useState("");
  const [nricnumber, setNRICNumber] = useState("");
  const [racenumber, setRaceNumber] = useState("");
  const [selecttime, setSelectTime] = useState("12.30 PM");
  const [selectreferral, setSelectReferral] = useState("1");
  const [allCountries, setAllCoountries] = useState("");
  const [allCenter, setAllCenter] = useState("");
  const [Familyname, setFamilyName] = useState("");
  const [Familynumber, setFamilyNumber] = useState("");
  const [Familynumberhp, setFamilyNumberHp] = useState("");
  const [relationshiptopatient, setRelationShiptoPatient] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // For Office USE
  const [selectstate, setSelectState] = useState("");
  const [onset, setOnSet] = useState("");
  const [onsetl, setOnSetL] = useState("");
  const [onsetR, setOnSetR] = useState("");
  const [birth, setBirth] = useState("");
  const [Gradual, setGradual] = useState("");
  const [Student, setStudent] = useState("");
  const [otherphasestate, setOtherPhaseState] = useState("");
  const [earpain, setEarPain] = useState("");
  const [headinjury, setHeadInjury] = useState("");
  const [medicalcondition, setMedicalCondition] = useState("");
  const [discharge, setDischarge] = useState("");
  const [surgery, setSurgery] = useState("");
  const [currentmedication, setCurrentMedication] = useState("");
  const [headache, setHeadache] = useState("");
  const [nosieexposure, setNosieExposure] = useState("");
  const [sinusitus, setSinusitus] = useState("");
  const [painswallowing, setPainSwallowing] = useState("");
  const [familyhistory, setFamilyHistory] = useState("");
  const [vertigo, setVertigo] = useState("");
  const [fullnessofear, setFullnessOfEar] = useState("");
  const [tinnitus, setTinnitus] = useState("");
  const [vomiting, setVomiting] = useState("");

  // Area of Difficulty

  const [onetoone, setOneToOne] = useState("");
  const [meeting, setMeeting] = useState("");
  const [television, setTelevision] = useState("");
  const [backgroundnoise, setBackgroundNoise] = useState("");
  const [group, setGroup] = useState("");
  const [church, setChurch] = useState("");
  const [telephone, setTelephone] = useState("");
  const [other, setOther] = useState("");
  const [remarks, setRemarks] = useState("");

  const getAppointmentData = () => {
    setIsLoading(true);
    const userid = {
      user_id: localStorage.getItem("id"),
    };
    dispatch(ViewBookAppointment(userid))
      .then((res) => {
        if (res?.payload?.status === true) {
          setGetAppointment(res?.payload?.data);
          // console.log(res?.payload?.data, "ff");
        } else {
          // toast.error(res?.payload?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching test data:", error);
        // Handle error if needed
      })
      .finally(() => {
        setIsLoading(false); // Set loading to false after data fetching completes
      });
  };

  function Viewclick(item) {
    setAddMenuOpen(true);
    console.log(item, "sss");
    setSelectCenter(item?.branch_name);
    setFirstName(item?.first_name);
    setLastName(item?.last_name);
    const splitDatetime = item.dob.split(" ");
    const dateOnly = splitDatetime[0];
    setDOB(moment(dateOnly).format("MM/DD/YYYY"));
    setGander(item?.gender);
    setNationality(item?.country_id);
    setEmail(item?.email);
    setAddress(item?.address_line_first);
    setAddress2(item?.address_line_second);
    setSelectTime(item?.time);
    setMobileNumber(item?.mobile_number);
    setPostalcode(item?.postal_code);
    setNRICNumber(item?.niric_number);
    setRaceNumber(item?.race_number);
    setLanguagesSpoken(item?.contact_lang);
    setHomeNumber(item?.family_member_contact_no);
    setFamilyName(item?.family_member_name);
    // family_member_relation;
    setFamilyNumberHp(item?.family_member_hp);
    setOnSet(item?.onset);
    setOnSetR(item?.right);
    setOnSetL(item?.left);
    setGradual(item?.gradual);
    setStudent(item?.student);
    setBirth(item?.birth);
    setOtherPhaseState(item?.other_phase_state);
    setEarPain(item?.ear_pain);
    setHeadInjury(item?.head_injury);
    setMedicalCondition(item?.medical_condition);
    setDischarge(item?.discharge);
    setSurgery(item?.surgery);
    setCurrentMedication(item?.current_medication);
    setHeadache(item?.headache);
    setVomiting(item?.vomating);
    setNosieExposure(item?.noise_exposure);
    setSinusitus(item?.sinusitus);
    setPainSwallowing(item?.pain_swallowing);
    setFamilyHistory(item?.family_history);
    setVertigo(item?.vertigo);
    setFullnessOfEar(item?.fullness_of_ear);
    setTinnitus(item?.tinnitus);
    setOneToOne(item?.one_to_one);
    setMeeting(item?.meeting);
    setTelevision(item?.television);
    setBackgroundNoise(item?.background_noise);
    setGroup(item?.group);
    setChurch(item?.church);
    setTelephone(item?.telephone);
    setOther(item?.other);
    setRemarks(item?.remarks);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = "#f00";
  }

  function closeViewPopup() {
    setShowview(false);
  }

  // const Viewclickdata = (item) => {
  //   console.log(item, "sss");
  //   Viewclick();
  // };

  const handleClose = () => {
    setAddMenuOpen(false);
  };

  const getcountriData = () => {
    dispatch(getCountries()).then((res) => {
      if (res?.payload?.status === true) {
        setAllCoountries(res?.payload?.data);
        // console.log(res?.payload?.data);
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };

  const Countries = Array.isArray(allCountries)
    ? allCountries.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    : [];

  const [referralOptions, setReferralOptions] = useState([]);
  const getreferralOptions = () => {
    try {
      dispatch(appointmentReferralOption()).then((res) => {
        if (res?.payload?.status === true) {
          setReferralOptions(res?.payload?.data);
        } else {
          setReferralOptions([]);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getAppointmentData();
    getcountriData();
    getreferralOptions();
  }, []);

  const currentDay = new Date().getDay();
  return (
    <>
      {/* <div
        className="side_div_menu"
        style={{ display: "flex", height: "100%" }}
      > */}
      {/* <Sidebarmenu /> */}

      <div className="container-fluid">
        <div className="Myhistory">
          {/* <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    Appointment History
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    Profile
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-contact-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-contact"
                    type="button"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                  >
                    Contact
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  3
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  2
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-contact"
                  role="tabpanel"
                  aria-labelledby="pills-contact-tab"
                >
                  2
                </div>
              </div> */}

          <div className="table-responsive">
            <table className="table invoice_tabel">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"> Patients Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Date</th>
                  <th scope="col">Audiologist Name</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  // Render a loader while data is being fetched
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      <img src={loder} className="img-fluid" alt="loder" />
                    </td>
                  </tr>
                ) : (
                  Array.isArray(getappointment) &&
                  getappointment
                    .slice() // Create a copy of the array to avoid mutating the original
                    .sort(
                      (a, b) =>
                        new Date(b.start_date_time) -
                        new Date(a.start_date_time)
                    ) // Sort dates in ascending order
                    .map((item, index) => (
                      <tr key={item?.id}>
                        <td>{index + 1}</td>
                        <td>{item?.first_name}</td>
                        <td>{item?.email}</td>
                        <td>
                          {moment(item?.start_date_time).format("DD/MM/YYYY")}
                        </td>
                        <td>{item?.audiologist_name}</td>
                        <td>
                          <div className="myhistory_list">
                            {/* <a onClick={() => Viewclick(item)}> */}
                            <i
                              onClick={() => Viewclick(item)}
                              className="fa fa-eye"
                              aria-hidden="true"
                            ></i>
                            {/* </a> */}

                            {/* <a href="#">
                                  <i
                                    className="fa fa-trash-o"
                                    aria-hidden="true"
                                  ></i>
                                </a> */}
                          </div>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Offcanvas
        className="offcanvas_popup"
        show={addmenuopen}
        onHide={handleClose}
        placement="end"
        id="my_view"
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            My History
            {/* <span>{moment(creactdate).format("MM/DD/YYYY")}</span> */}
            <button className="back_canvas" onClick={handleClose}>
              {" "}
              <ImCross />
            </button>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="container p-0">
            <form>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="SelectCenter"
                      placeholder="Select Center"
                      value={selectcenter}
                      disabled
                      // onChange={(e) => setLastName(e.target.value)}
                    />
                    <label for="SelectCenter">Select Center</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="FirstName"
                      placeholder="First Name"
                      value={firstname}
                      disabled
                      // onChange={(e) => setFirstName(e.target.value)}
                    />
                    <label for="FirstName">Patients First Name</label>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="LastName"
                      placeholder="Last Name"
                      value={lastname}
                      disabled
                      // onChange={(e) => setLastName(e.target.value)}
                    />
                    <label for="LastName">Patients Last Name</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div class="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="DateofBirth"
                      placeholder="DD/MM/YYYY"
                      value={dob}
                      // onChange={handledate}
                    />
                    <label for="DateofBirth">Date of Birth</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div class="form-floating">
                    <select
                      class="form-select"
                      id="floatingSelect"
                      value={gandar}
                      aria-label="Floating label select example"
                      // onChange={handleChangegender}
                    >
                      {/* <option selected>Select Center</option> */}
                      <option value="1">Male</option>
                      <option value="2">Female</option>
                      <option value="3">Other</option>
                    </select>
                    <label for="floatingSelect">Gander</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      value={nationality}
                      // onChange={handleChangenationality}
                    >
                      {Countries.map((country) => (
                        <option key={country.value} value={country.value}>
                          {country.label}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="floatingSelect">Nationality</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="email"
                      className="form-control"
                      id="EmailAddress"
                      placeholder="Email Address"
                      value={email}
                      // onChange={(e) => setEmail(e.target.value)}
                    />
                    <label for="EmailAddress">Email Address</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="AddressLine1 "
                      placeholder="Address Line1"
                      value={address}
                      // onChange={(e) => setAddress(e.target.value)}
                    />
                    <label for="Address Line1">Address Line1</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="AddressLine2"
                      placeholder="Address Line2"
                      value={address2}
                      // onChange={(e) => setAddress2(e.target.value)}
                    />
                    <label for="Address Line2">Address Line2</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Postalcode"
                      placeholder="Postal code"
                      value={Postalcode}
                      // onChange={(e) => setPostalcode(e.target.value)}
                    />
                    <label for="Postalcode">Postal code</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="NRICNumber"
                      placeholder="NRICNumber"
                      value={nricnumber}
                      // onChange={(e) => setNRICNumber(e.target.value)}
                    />
                    <label for="NRICNumber">NRIC Number</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="RaceNumber"
                      placeholder="RaceNumber"
                      value={racenumber}
                      // onChange={(e) => setRaceNumber(e.target.value)}
                    />
                    <label for="RaceNumber">Race Number</label>
                  </div>
                </div>

                <div className="col-md-6">
                  {/* <div class="form-floating">
                    <select
                      class="form-select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      value={selecttime}
                      // onChange={handleChangetime}
                    >
                      {currentDay != 6 ? (
                        <>
                      
                          <option value="9.00 AM">9.00 AM (Mon- Fri) </option>
                          <option value="9.30 AM">9.30 AM (Mon- Fri) </option>
                          <option value="10 AM">10.00 AM (Mon- Fri) </option>
                          <option value="10.30 AM">10.30 AM (Mon- Fri) </option>
                          <option value="11.00 AM">11.00 AM (Mon- Fri) </option>
                          <option value="11.30 AM">11.30 AM (Mon- Fri) </option>
                          <option value="12.00 PM">12.00 PM (Mon- Fri) </option>
                          <option value="12.30 PM">12.30 PM (Mon- Fri) </option>
                          <option value="1.00 PM">1.00 PM (Mon- Fri) </option>
                          <option value="1.30 PM">1.30 PM (Mon- Fri) </option>
                          <option value="2.00 PM">2.00 PM (Mon- Fri) </option>
                          <option value="2.30 PM">2.30 PM (Mon- Fri) </option>
                          <option value="3.00 PM">3.00 PM (Mon- Fri) </option>
                          <option value="3.30 PM">3.30 PM (Mon- Fri) </option>
                          <option value="4.00 PM">4.00 PM (Mon- Fri) </option>
                          <option value="4.30 PM">4.30 PM (Mon- Fri) </option>
                          <option value="5.00 PM">5.00 PM (Mon- Fri) </option>
                          <option value="5.30">5.30 PM (Mon- Fri) </option>
                    
                        </>
                      ) : (
                        <>
                          <option value="9.30 AM">9.30 AM (Sat)</option>
                          <option value="10.00 AM">10.00 AM (Sat)</option>
                          <option value="10.30 AM">10.30 AM (Sat)</option>
                          <option value="11.00 AM">11.00 AM (Sat)</option>
                          <option value="11.30 AM">11.30 AM (Sat)</option>
                          <option value="12.00 PM">12.00 PM (Sat)</option>
                          <option value="12.30 PM">12.30 PM (Sat)</option>{" "}
                        </>
                      )}
                    </select>
                    <label for="floatingSelect">Clinic Time</label>
                  </div> */}

                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="AddressLine2"
                      placeholder="ClinicTime"
                      value={selecttime}
                      // onChange={(e) => setAddress2(e.target.value)}
                    />
                    <label for="ClinicTime">Clinic Time</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div class="form-floating">
                    <select
                      class="form-select"
                      id="floatingSelectdr"
                      aria-label="Floating label select example"
                      value={selectreferral}
                      // onChange={handleReferral}
                    >
                      {referralOptions?.map((option, i) => (
                        <option key={i} value={option?.id}>
                          {option?.title}
                        </option>
                      ))}
                    </select>
                    <label for="floatingSelectdr">Referral Source</label>
                  </div>
                </div>
                <h6 className="info_text">Contact Information</h6>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="LanguageSpoken"
                      placeholder="LanguageSpoken"
                      value={languagesspoken}
                      // onChange={(e) => setLanguagesSpoken(e.target.value)}
                    />
                    <label for="LanguageSpoken">Language Spoken</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Mobile/HPNoumber"
                      placeholder="Mobile/HP Number"
                      value={mobilenumber}
                      // onChange={(e) => setMobileNumber(e.target.value)}
                    />
                    <label for="Mobile/HPNoumber">Mobile/HP Number</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="HomeNumber"
                      placeholder="Home Number"
                      value={Homenumber}
                      // onChange={(e) => setHomeNumber(e.target.value)}
                    />
                    <label for="HomeNumber">Home Number</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="OfficeNumber"
                      placeholder="Office Number"
                      value={officenumber}
                      onChange={(e) => setOfficeNumber(e.target.value)}
                    />
                    <label for="OfficeNumber">Office Number</label>
                  </div>
                </div>

                <h6 className="info_text">Other Family Members To Contact</h6>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Name"
                      placeholder="Name"
                      value={Familyname}
                      // onChange={(e) => setFamilyName(e.target.value)}
                    />
                    <label for="Name">Name</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="relationshiptopatient"
                      placeholder="Relationship to patient"
                      // onChange={(e) => setRelationShiptoPatient(e.target.value)}
                      value={relationshiptopatient}
                    />
                    <label for="relationshiptopatient">
                      Relationship to patient
                    </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="ContactNumber"
                      placeholder="Contact Number"
                      // onChange={(e) => setFamilyNumber(e.target.value)}
                      value={Familynumber}
                    />
                    <label for="ContactNumber">Contact Number</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="HP"
                      placeholder="HP"
                      // onChange={(e) => setFamilyNumberHp(e.target.value)}
                      value={Familynumberhp}
                    />
                    <label for="HP">HP</label>
                  </div>
                </div>

                <h6 className="info_text">For Office USE</h6>
                <p className="for_office">
                  Referral Source: From where did you find out about The{" "}
                  <span>Hearing Centre?</span>
                </p>

                <div className="col-md-12">
                  <div class="form-floating">
                    <select
                      class="form-select"
                      id="floatingSelect"
                      aria-label="Floating label select example"
                      value={selectstate}
                      // onChange={handleChangestate}
                    >
                      {/* <option selected>Select Center</option> */}
                      <option value="1">MP</option>
                      <option value="2">MH</option>
                      <option value="3">UP</option>
                    </select>
                    <label for="floatingSelect">Please Select State</label>
                  </div>
                </div>

                <h6 className="info_text">Complaint Of</h6>

                <div className="col-md-12">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Onset"
                      placeholder="Onset"
                      // onChange={(e) => setOnSet(e.target.value)}
                      value={onset}
                    />
                    <label for="Onset">Onset</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="R"
                      placeholder="R"
                      // onChange={(e) => setOnSetR(e.target.value)}
                      value={onsetR}
                    />
                    <label for="R">R</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="L"
                      placeholder="L"
                      // onChange={(e) => setOnSetL(e.target.value)}
                      value={onsetl}
                    />
                    <label for="L">L</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Gradual"
                      placeholder="Gradual"
                      // onChange={(e) => setGradual(e.target.value)}
                      value={Gradual}
                    />
                    <label for="Gradual">Gradual</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Student"
                      placeholder="Student"
                      // onChange={(e) => setStudent(e.target.value)}
                      value={Student}
                    />
                    <label for="Student">Student</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Birth"
                      placeholder="Birth"
                      // onChange={(e) => setBirth(e.target.value)}
                      value={birth}
                    />
                    <label for="Birth">Birth</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="Other(Phase State)"
                      placeholder="Other(Phase State)"
                      // onChange={(e) => setOtherPhaseState(e.target.value)}
                      value={otherphasestate}
                    />
                    <label for="Other(Phase State)">Other(Phase State)</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="EarPain"
                      placeholder="EarPain"
                      // onChange={(e) => setEarPain(e.target.value)}
                      value={earpain}
                    />
                    <label for="EarPain">Ear Pain</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="HeadInjury"
                      placeholder="Head Injury"
                      // onChange={(e) => setHeadInjury(e.target.value)}
                      value={headinjury}
                    />
                    <label for="HeadInjury">Head Injury</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="medicalcondition"
                      placeholder="Medical Condition"
                      // onChange={(e) => setMedicalCondition(e.target.value)}
                      value={medicalcondition}
                    />
                    <label for="medicalcondition">Medical Condition</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="discharge"
                      placeholder="Discharge"
                      // onChange={(e) => setDischarge(e.target.value)}
                      value={discharge}
                    />
                    <label for="discharge">Discharge</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="surgery"
                      placeholder="Surgery"
                      // onChange={(e) => setSurgery(e.target.value)}
                      value={surgery}
                    />
                    <label for="surgery">Surgery</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="currentmedication"
                      placeholder="Current Medication"
                      // onChange={(e) => setCurrentMedication(e.target.value)}
                      value={currentmedication}
                    />
                    <label for="currentmedication">Current Medication</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="headache"
                      placeholder="Headache"
                      // onChange={(e) => setHeadache(e.target.value)}
                      value={headache}
                    />
                    <label for="headache">Headache</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="vomiting"
                      placeholder="Vomiting"
                      // onChange={(e) => setVomiting(e.target.value)}
                      value={vomiting}
                    />
                    <label for="vomiting">Vomiting</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="nosieexposure"
                      placeholder="Nosie Exposure."
                      // onChange={(e) => setNosieExposure(e.target.value)}
                      value={nosieexposure}
                    />
                    <label for="NosieExposure">Nosie Exposure.</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="sinusitus"
                      placeholder="Sinusitus"
                      // onChange={(e) => setSinusitus(e.target.value)}
                      value={sinusitus}
                    />
                    <label for="sinusitus">Sinusitus</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="painswallowing"
                      placeholder="Pain Swallowing"
                      // onChange={(e) => setPainSwallowing(e.target.value)}
                      value={painswallowing}
                    />
                    <label for="painswallowing">Pain Swallowing</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="familyhistory"
                      placeholder="Family History"
                      // onChange={(e) => setFamilyHistory(e.target.value)}
                      value={familyhistory}
                    />
                    <label for="familyhistory">Family History </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="vertigo"
                      placeholder="Vertigo"
                      // onChange={(e) => setVertigo(e.target.value)}
                      value={vertigo}
                    />
                    <label for="vertigo">Vertigo</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="fullnessofear"
                      placeholder="Fullness of ear"
                      // onChange={(e) => setFullnessOfEar(e.target.value)}
                      value={fullnessofear}
                    />
                    <label for="fullnessofear">Fullness of Ear</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="tinnitus"
                      placeholder="Tinnitus"
                      // onChange={(e) => setTinnitus(e.target.value)}
                      value={tinnitus}
                    />
                    <label for="tinnitus">Tinnitus</label>
                  </div>
                </div>

                <h6 className="info_text">Area of Difficulty</h6>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="1to1"
                      placeholder="1 to 10"
                      // onChange={(e) => setOneToOne(e.target.value)}
                      value={onetoone}
                    />
                    <label for="1to1">1 to 10 </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="meeting"
                      placeholder="Meeting"
                      // onChange={(e) => setMeeting(e.target.value)}
                      value={meeting}
                    />
                    <label for="meeting">Meeting</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="television"
                      placeholder="Television"
                      // onChange={(e) => setTelevision(e.target.value)}
                      value={television}
                    />
                    <label for="television">Television</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="backgroundnoise"
                      placeholder="Background noise"
                      // onChange={(e) => setBackgroundNoise(e.target.value)}
                      value={backgroundnoise}
                    />
                    <label for="backgroundnoise">Background noise</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="group"
                      placeholder="group"
                      // onChange={(e) => setGroup(e.target.value)}
                      value={group}
                    />
                    <label for="group">group </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="church"
                      placeholder="Church"
                      // onChange={(e) => setChurch(e.target.value)}
                      value={church}
                    />
                    <label for="church">Church</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="telephone"
                      placeholder="Telephone"
                      // onChange={(e) => setTelephone(e.target.value)}
                      value={telephone}
                    />
                    <label for="telephone">Telephone</label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-floating">
                    <input
                      type="text"
                      className="form-control"
                      id="other"
                      placeholder="Other"
                      // onChange={(e) => setOther(e.target.value)}
                      value={other}
                    />
                    <label for="other">Other</label>
                  </div>
                </div>

                <div className="col-md-12">
                  <div class="form-floating">
                    <textarea
                      class="form-control"
                      placeholder="Leave a Comment Here"
                      id="remarks"
                      rows="8"
                      style={{ height: "200px" }}
                      // onChange={(e) => setRemarks(e.target.value)}
                      value={remarks}
                    ></textarea>
                    <label for="remarks">Remarks</label>
                  </div>
                </div>

                {/* <div className="col-md-12">
                  <button type="submit" className="btn Save_btn">
                    Book Appointment
                  </button>
                </div> */}
              </div>
            </form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default MyHistory;
